import React, {useState} from 'react'

import {
  ModalHamburguer,
  Nav,
  NavLogo,
  NavButton,
  MenuHamburguer
} from './nav.style'


export default function WebPageAndProgramming (props) {
  console.log('Estos son los props', props)
  const [ modalHamburguer, setModalHamburguer ] = useState(false)
  const [test1, setTest1] = useState(false)
  const [ruta, setRuta] = useState(props)
  // const [pruebas2, setPruebas2] = useState(false)
  

  const sendToQuotation = () => props.history.push('/cotizacion')

  const showModalHamburguer = () => setModalHamburguer(true)

  const closeModalHamburguer = () => setModalHamburguer(false)

  const mousePrueba = () =>  setTest1(!test1)

  // const prueba2 = (evento) => {
  //   console.log(evento)
  //   console.log('page x', evento.pageX)
  //   console.log('page y', evento.pageY)
  //   console.log('relatedTarget', evento.relatedTarget.attributeStyleMap.size)

  //   if(evento.pageX >= 400 ){
  //     console.log('Soy mayor a 400')
  //     setPruebas2('Mayor')

  //   }else {
  //     console.log('Soy menor a 400')
  //     setPruebas2('Menor')
  //   }
  // }
  
  return ( 
    <>
      <ModalHamburguer showModalHamburguer={modalHamburguer}>
        <div>
          <div>
            <div onClick={closeModalHamburguer}></div>
          </div>
          <div>
            <div>
              <a href="/">HOME</a>
            </div>
            <div>
              <a href="/servicios">SERVICIOS</a>
            </div>
            <div>
              <a href="/reel">REEL</a>
            </div>
            <div>
              <a href="/contactanos">CONTACTO</a>
            </div>
          </div>
        </div>
      </ModalHamburguer>
      <Nav/>
      <Nav>
        <NavLogo>
          <a href="/">
            <figure >
              {ruta === 'servicios'&&<img src="https://s3.amazonaws.com/atrium1.0/logotipo_auricula_rosa.png" alt="" /> }
              {ruta === 'reel'&&<img src="https://s3.amazonaws.com/atrium1.0/logotipo_auricula_amarillo.png" alt="" /> }
              {ruta === 'contactanos'&&<img src="https://s3.amazonaws.com/atrium1.0/logotipo_auricula_gris.png" alt="" /> }
              <img src="https://s3.amazonaws.com/atrium1.0/logotipo_auricula_rosa.png" alt="" />
            </figure>
          </a>
        </NavLogo>
        <NavButton>
          <div>
            <a href="/">HOME</a>
          </div>
          <div>
            <a href="/test/servicios">SERVICIOS</a>
          </div>
          <div>
            <a href="/test/reel">REEL</a>
          </div>
          <div>
            <a href="/test/contactanos">CONTACTO</a>
          </div>
        </NavButton>
        <MenuHamburguer onClick={showModalHamburguer}>
          <div></div>
          <div></div>
          <div></div>
        </MenuHamburguer>
      </Nav>
      

    </>
  )
}


